import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { MoneyProvider } from './contexts/MoneyContext';

ReactDOM.createRoot(document.getElementById('root')).render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
            <ToastProvider>
                <MoneyProvider>
                    <App />
                </MoneyProvider>
            </ToastProvider>
        </AuthProvider>
    </ThemeProvider>
);
